import { ClientError, publicRequest } from './client';
import { sortOldestFirst } from '@/helpers/candidateMessaging';
import type { PublicChatMessage, PublicChatThread, PublicFileRequest } from '@/types/candidate';

/** whether the link was used after its order finished, which the backend marks with `error: order_finished` */
export function isOrderFinishedError(error: unknown): boolean {
  return error instanceof ClientError && error.responseJson?.error === 'order_finished';
}

/* --------------------------------- FILE UPLOAD ------------------------------- */

export async function fetchPublicFileRequest(token: string): Promise<PublicFileRequest> {
  const response = await publicRequest<{ data: PublicFileRequest }>(
    'GET',
    `/v1/form/upload/${encodeURIComponent(token)}`
  );
  return response.data;
}

export async function uploadFileRequestFiles(token: string, files: File[]): Promise<void> {
  const formData = new FormData();
  for (const file of files) {
    formData.append('files[]', file);
  }

  await publicRequest('POST', `/v1/form/upload/${encodeURIComponent(token)}`, formData);
}

/* ---------------------------------- CHAT REPLY ------------------------------- */

export async function fetchChatThread(token: string): Promise<PublicChatThread> {
  const response = await publicRequest<{
    data: PublicChatMessage[];
    company_name?: string | null;
    language?: string | null;
  }>('GET', `/v1/form/reply/${encodeURIComponent(token)}`);

  return {
    messages: sortOldestFirst(response.data ?? []),
    company_name: response.company_name ?? null,
    language: response.language ?? null,
  };
}

export async function postChatReply(token: string, body: string): Promise<PublicChatMessage> {
  const response = await publicRequest<{ data: PublicChatMessage }>(
    'POST',
    `/v1/form/reply/${encodeURIComponent(token)}`,
    { body }
  );
  return response.data;
}
